// extracted by mini-css-extract-plugin
export default {"zoomModal":"q2-z"};